import React from 'react';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';
import {Props} from './FormField';
import app from '../../helpers/app';
import getUri from '../../helpers/getUri';
import {useFormContext} from 'react-hook-form';

export function LinkToRelationFormPage(props: {
    relationModel: string,
    modelId: string | number,
    children: React.ReactNode,
}) {
    const {relationModel, modelId} = props;

    const routeName = app('names-resolver').clientRoutes.getShowRouteName(relationModel);
    const url = routeName ? getUri({
        route: routeName,
        params: {id: String(modelId)}
    }) : null;

    if (!url || !modelId) {
        return <>{props.children}</>;
    }

    return <>
        {props.children}
        <a href={url} target="_blank" rel="noreferrer" className="py-1 px-2 ms-2 rounded">
            <i className="fas fa-arrow-up-right-from-square"/>
        </a>
    </>;
}

export default function FormLinkToRelationFormPage<Model extends IEmptyModel>(props: Props<Model>) {
    const context = useFormContext();

    let value;
    if (
            props.config.type !== 'relation' ||
            !props.config.relation ||
            !props.config.relationModel ||
            !['string', 'number'].includes(
                    typeof (value = context.getValues(props.config.relation))
            )
    ) {
        return <>{props.children}</>;
    }

    return <LinkToRelationFormPage modelId={value} relationModel={props.config.relationModel}>
        {props.children}
    </LinkToRelationFormPage>;
}
